function runWhenInit() {

  console.log("The current cart state is: ", window.liquidAjaxCart.cart);

}

if (window.liquidAjaxCart?.init) {

    // if Liquid Ajax Cart is already initialized
  runWhenInit();

} else {

    // wait for Liquid Ajax Cart to be initialized
  document.addEventListener("liquid-ajax-cart:init", runWhenInit);

}

    // Listen for the "liquid-ajax-cart:request-end" event which is fired
    // after a Shopify Cart API Ajax request is performed
document.addEventListener('liquid-ajax-cart:request-end', event => {
  const {requestState} = event.detail;

      // If the "add to cart" request is successful
  if (requestState.requestType === 'add' && requestState.responseData?.ok) {

        // Add the CSS class to the "body" tag
    document.body.classList.add('js-show-ajax-cart');
        // window.location = "/cart";

  }

});
